import {
	SET_FORM_STATE,
	RESET_FIELDS,
	GET_INCIDENT_TRACKER_TRACKER,
	TOGGLE_INCIDENT_TRACKER_DIALOG,
	GET_INCIDENT_TRACKER_TRACKER_DETAILS,
	GET_INCIDENT_TRACKER_TRACKER_DROPDOWNS,
	TOGGLE_DELETE_INCIDENT_TRACKER_DIALOG,
	GET_INCIDENT_TRACKER_AUTOCOMPLETE,
	TOGGLE_ATTACH_FILE_INCIDENT_TRACKER_DIALOG,
	TOGGLE_REMOVE_FILE_INCIDENT_TRACKER_DIALOG,
	TOGGLE_OPTIONS_INCIDENT_TRACKER_DIALOG,
	TOGGLE_OPTIONS_INCIDENT_TRACKER_FORM,
	GET_COMMENTS,
	ADD_DROPDOWN_FIELD
} from '../actions/IncidentTrackerActions';

const initialState = {
	incidents: [],
	IncidentTrackerDialogVisibility: false,
	incidentDetails: [],
	dropdowns: [],
	incidentTrackerDto: [],
	trackerCommentDto: [],
	tableId: '',
	deleteIncidentTrackerDialogVisibility: false,
	attachFileIncidentTrackerDialogVisibility: false,
	removeFileIncidentTrackerDialogVisibility: false,
	optionsIncidentTrackerDialogVisibility: false,
	optionsIncidentTrackerFormVisibility: false,
	dropdownLabel: '',
	dropdownName: '',
	dropdownValue: '',
	dropdownId: undefined,
	autocompleteFields: [],
	comments: [],
	newDropdownField: '',
	formState: {
		values: {
			inputFilePath: '',
			closedDate: '',
			ticketClosedFlag: false,
			disableModalSaveButton: false
		},
		isValid: false,
		touched: {},
		errors: {}
	}
};

const incidentTrackerDemoReducer = (state = initialState, action) => {
	switch (action.type) {
					case SET_FORM_STATE: {
						return {
							...state,
							formState: action.formState
						};
					}
					case RESET_FIELDS: {
						return {
							...state,
							drives: [],
							dates: []
						};
					}
					case GET_INCIDENT_TRACKER_TRACKER: {
						return {
							...state,
							incidents: action.incidents
						};
					}
					case TOGGLE_INCIDENT_TRACKER_DIALOG: {
						return {
							...state,
							IncidentTrackerDialogVisibility: action.visible,
							tableId: action.tableId,
							formState: initialState.formState
						};
					}
					case GET_INCIDENT_TRACKER_TRACKER_DETAILS: {
						return {
							...state,
							formState: {
								...state.formState,
								values: { ...action.incidentDetails }
							},
							incidentDetails: action.incidentDetails
						};
					}
					case GET_INCIDENT_TRACKER_TRACKER_DROPDOWNS: {
						return {
							...state,
							dropdowns: action.dropdowns
						};
					}
					case TOGGLE_DELETE_INCIDENT_TRACKER_DIALOG: {
						return {
							...state,
							deleteIncidentTrackerDialogVisibility: action.visible,
							tableId: action.tableId
						};
					}
					case GET_INCIDENT_TRACKER_AUTOCOMPLETE: {
						return {
							...state,
							autocompleteFields: action.autocompleteFields
						};
					}
					case TOGGLE_ATTACH_FILE_INCIDENT_TRACKER_DIALOG: {
						return {
							...state,
							attachFileIncidentTrackerDialogVisibility: action.visible
						};
					}
					case TOGGLE_REMOVE_FILE_INCIDENT_TRACKER_DIALOG: {
						return {
							...state,
							removeFileIncidentTrackerDialogVisibility: action.visible
						};
					}
					case TOGGLE_OPTIONS_INCIDENT_TRACKER_DIALOG: {
						return {
							...state,
							optionsIncidentTrackerDialogVisibility: action.visible
						};
					}
					case TOGGLE_OPTIONS_INCIDENT_TRACKER_FORM: {
						return {
							...state,
							optionsIncidentTrackerFormVisibility: action.visible,
							dropdownLabel: action.dropdownLabel,
							dropdownName: action.dropdownName,
							dropdownValue: action.dropdownValue,
							dropdownId: action.dropdownId
						};
					}
					case GET_COMMENTS: {
						return {
							...state,
							comments: action.comments
						};
					}
					case ADD_DROPDOWN_FIELD: {
						return {
							...state,
							newDropdownField: action.newDropdownField
						};
					}
					default: {
						return state;
					}
	}
};

export default incidentTrackerDemoReducer;
